import { Locale, translate } from "./translations";

const ja: Locale = {
  welcome: "APAATOへようこそ",
  signIn: "サインイン",
  register: "登録",
  accountType: "アカウント種別",
  accountTypeUser: "ユーザー",
  accountTypePartner: "パートナー",
  firstName: "名",
  lastName: "姓",
  orgName: "組織名",
  createAccount: "アカウント作成",
  registrationRequired: "続行するには登録を完了してください。",
  signOut: "サインアウト",
  greeting: (name: string) => `こんにちは、${name}`,
  email: "メールアドレス",
  password: "パスワード",
  continueWithGoogle: "Googleで続行",
  pleaseWait: "お待ちください...",
  fillAllFields: "すべての項目を入力してください。",
  userNotFound: "このメールアドレスのユーザーは見つかりませんでした。",
  wrongPassword: "パスワードが正しくありません。",
  authFailed: "認証に失敗しました。もう一度お試しください。",
  signInCancelled: "サインイン処理がキャンセルされました。",
  googleSignInFailed:
    "Googleでのサインインに失敗しました。もう一度お試しください。",
  notAuthorized: "この環境へのアクセスは許可されていません。",
  registrationFailed: "登録に失敗しました。もう一度お試しください。",

  confirmPassword: "パスワード（確認）",
  accountTypeUserHint: "日本で部屋を探したい",
  accountTypePartnerHint: "住宅の広告を掲載したい",
  show: "表示",
  hide: "非表示",
  emailRequired: "メールアドレスは必須です",
  emailInvalid: "正しいメールアドレスを入力してください",
  passwordRequired: "パスワードは必須です",
  passwordMin8: "パスワードは8文字以上にしてください",
  passwordNeedNumber: "パスワードに数字を1つ以上含めてください",
  passwordNeedSymbol: "パスワードに記号を1つ以上含めてください",
  passwordNeedUpper: "パスワードに大文字を1つ以上含めてください",
  passwordNeedLower: "パスワードに小文字を1つ以上含めてください",

  passwordRequirements: "パスワード要件",
  passwordReqMin8: "8文字以上",
  passwordReqNumber: "数字を1つ以上",
  passwordReqSymbol: "記号を1つ以上",
  passwordReqUpper: "大文字を1つ以上",
  passwordReqLower: "小文字を1つ以上",

  notVerified: "メールを確認してからサインインしてください。",
  forbidden: "この環境へのアクセスは許可されていません。",

  confirmPasswordRequired: "パスワードを再入力してください",
  passwordsDontMatch: "パスワードが一致しません",
  firstNameRequired: "名は必須です",
  lastNameRequired: "姓は必須です",
  orgNameRequired: "組織名は必須です",

  // Email verification flow
  verificationSentTitle: "メールを確認してください",
  verificationSentBody: (email: string) =>
    `${email}に確認メールを送信しました。受信箱を確認し、リンクをクリックしてアカウントを認証してください。`,
  okGotIt: "了解",
  emailConfirmedTitle: "メール認証完了",
  emailConfirmedBody:
    "ありがとうございます！メールが認証されました。アカウントにログインできます。",
  logIntoAccount: "ログイン",

  // Verification page
  verificationFailedTitle: "認証に失敗しました",
  verificationExpired:
    "この認証リンクは有効期限が切れています。新しいリンクをリクエストしてください。",
  verificationInvalid: "この認証リンクは無効か、既に使用されています。",
  verificationFailed:
    "メールの認証ができませんでした。後でもう一度お試しください。",
  verificationMissingCodeTitle: "認証コードがありません",
  verificationMissingCodeBody:
    "認証コードが提供されていません。メールのリンクをもう一度クリックしてください。",
  backToLogin: "サインインに戻る",
  resendVerificationEmail: "認証メールを再送信",
  resendVerificationHint: (email: string) =>
    `${email}に新しい認証リンクを送信しますか？`,
  verificationResent:
    "新しい認証メールを送信しました。受信箱をご確認ください。",
  resendFailed: "認証メールの送信に失敗しました。もう一度お試しください。",

  // Homepage
  dashboard: "ダッシュボード",
  homeHeroTitle: "日本で理想の住まいを見つけよう",
  homeHeroSubtitle:
    "東京の厳選されたアパートメントを、外国人居住者にも日本人にも。",
  searchPrefecture: "都道府県",
  searchSelectPrefecture: "都道府県を選択",
  searchCity: "市区町村",
  searchSelectCity: "市区町村を選択",
  searchLocation: "エリア",
  searchSelectArea: "エリアを選択",
  searchMoveIn: "入居日",
  searchMoveInPlaceholder: "日付を選択",
  searchOccupants: "入居者数",
  searchRentBudget: "月額予算",
  searchRoomLayout: "間取り",
  searchPerson: "名",
  searchPeople: "名",
  searchButton: "物件を検索",
  searchEditCriteria: "検索条件を編集",
  featureQualityTitle: "品質保証",
  featureQualityDesc: "すべての物件は品質と快適さが確認されています。",
  featureTrustedTitle: "信頼のパートナー",
  featureTrustedDesc: "認定された不動産会社やオーナーと提携。",
  featureSupportTitle: "現地サポート",
  featureSupportDesc: "多言語対応のチームが新生活をサポート。",
  disclaimerTitle: "MVP開発中",
  disclaimerBody:
    "これは初期MVPバージョンです。検索機能と物件一覧は近日公開予定です。現在は東京エリアのみサポートされます。",
  footerRights: "All rights reserved.",

  // Philosophy Section
  philosophyTitle: "私たちの理念",
  philosophySubtitle:
    "外国人の方が日本でアパートを探すプロセスをシンプルにしたいと考えています。",
  philosophyNoFeesTitle: "隠れた費用なし",
  philosophyNoFeesDesc:
    "完全な価格透明性。表示された価格がお支払い金額です — 驚きはありません。",
  philosophySimpleTitle: "シンプルなインターフェース",
  philosophySimpleDesc:
    "次の住まいを簡単に見つけられる、クリーンで直感的なデザイン。",
  philosophyQualityTitle: "高品質な物件情報",
  philosophyQualityDesc:
    "物件とアパートに関するすべての必要な詳細を備えた高品質な物件一覧。",
  philosophyVerifiedTitle: "認証済み不動産会社",
  philosophyVerifiedDesc:
    "信頼できる認証済みの不動産プロフェッショナルのみと提携。",

  // Snackbar messages
  welcomeUserSnackbar: "ようこそ！ダッシュボード機能は近日公開予定です。",
  welcomeAdminSnackbar: "おかえりなさい、管理者さん！",

  // Dashboard
  dashboardWelcome: "おかえりなさい",
  dashboardSubtitle: "お部屋探しと保存した物件を管理できます。",
  dashboardSearch: "検索",
  dashboardSearchDesc: "東京の物件を探す",
  dashboardFavorites: "お気に入り",
  dashboardFavoritesDesc: "保存した物件を見る",
  dashboardNotifications: "通知",
  dashboardNotificationsDesc: "検索の更新情報",
  dashboardSettings: "設定",
  dashboardSettingsDesc: "アカウントを管理",
  dashboardComingSoon: "機能開発中",
  dashboardComingSoonDesc: "これらの機能は現在開発中です。近日公開予定です！",
  dashboardDevTools: "開発者ツール",
  dashboardDevToolsDesc: "テストと開発用のAPIアクセス",
  dashboardTokenInfo: "IDトークンを使用してAPIリクエストを認証します：",
  dashboardShowToken: "トークンを表示",
  dashboardCopyToken: "トークンをコピー",
  dashboardCopied: "コピーしました！",
  dashboardTokenError:
    "トークンを取得できませんでした。ページを更新してください。",

  // Overview Page
  back: "戻る",
  overviewSearchingIn: "検索中",
  overviewListView: "リスト",
  overviewMapView: "地図",
  overviewResultsTitle: "検索結果",
  overviewNoResults: "0件の物件が見つかりました",
  overviewEmptyTitle: "物件が見つかりませんでした",
  overviewEmptyDesc:
    "フィルターや検索条件を調整して、より多くの物件を見つけてください。データは近日追加予定です。",
  overviewMapTitle: "地図表示",
  overviewMapComingSoon: "地図表示は近日公開",
  overviewMapComingSoonDesc:
    "物件の位置を示すインタラクティブマップは今後のアップデートで利用可能になります。",
  overviewLoading: "物件を検索中...",
  overviewResults: "件の物件が見つかりました",
  overviewErrorTitle: "エラーが発生しました",
  overviewRetry: "再試行",
  overviewLoadingMore: "読み込み中...",
  overviewLoadMore: "もっと見る",

  // Listing Card
  "listings.min": "分",
  "listings.month": "月",
  "listings.foreignerFriendly": "外国人可",
  "listings.petsAllowed": "ペット可",
  "listings.airConditioning": "AC",
  "listings.deposit": "敷金",
  "listings.keyMoney": "礼金",

  // Filters
  filtersTitle: "フィルター",
  filterReset: "リセット",

  // Filter Categories
  filterCategoryProperty: "物件タイプ",
  filterCategoryPrice: "価格・費用",
  filterCategorySize: "広さ・間取り",
  filterCategoryAmenities: "設備",
  filterCategoryBuilding: "建物",
  filterCategoryAccess: "アクセス",
  filterCategoryContract: "契約条件",

  // Property Types
  filterPropertyType: "物件タイプ",
  filterPropertyApartment: "アパート",
  filterPropertyMansion: "マンション",
  filterPropertyShareHouse: "シェアハウス",
  filterPropertyGuestHouse: "ゲストハウス",
  filterPropertyMonthlyMansion: "マンスリーマンション",

  // Room Layouts
  filterRoomLayout: "間取り",
  filterLayout1R: "1R",
  filterLayout1K: "1K",
  filterLayout1DK: "1DK",
  filterLayout1LDK: "1LDK",
  filterLayout2K: "2K",
  filterLayout2DK: "2DK",
  filterLayout2LDK: "2LDK",
  filterLayout3K: "3K",
  filterLayout3DK: "3DK",
  filterLayout3LDKPlus: "3LDK以上",

  // Price Filters
  filterMinRent: "最低家賃",
  filterMaxRent: "最高家賃",
  filterIncludeManagementFee: "管理費込み",
  filterKeyMoney: "礼金",
  filterDeposit: "敷金",
  filterGuarantor: "保証人",
  filterNoKeyMoney: "礼金なし",
  filterNoDeposit: "敷金なし",
  filterHalfMonth: "0.5ヶ月",
  filter1Month: "1ヶ月",
  filter2Months: "2ヶ月",
  filterAny: "指定なし",
  filterYes: "必要",
  filterNo: "不要",

  // Size Filters
  filterMinSize: "最小面積",
  filterMaxSize: "最大面積",

  // Amenities
  filterAirConditioning: "エアコン",
  filterWasherHookup: "洗濯機置場",
  filterWasherDryerInUnit: "洗濯乾燥機付き",
  filterBathToiletSeparate: "バス・トイレ別",
  filterBalcony: "バルコニー",
  filterFlooringWood: "フローリング",
  filterInternetIncluded: "インターネット込み",
  filterGasStove: "ガスコンロ",
  filterIHCooktop: "IHコンロ",

  // Building
  filterBuildingAge: "築年数",
  filterAnyAge: "指定なし",
  filterUnder5Years: "築5年以内",
  filterUnder10Years: "築10年以内",
  filterUnder20Years: "築20年以内",
  filterUnder30Years: "築30年以内",
  filterFloor: "階数",
  filterAnyFloor: "指定なし",
  filterFirstFloor: "1階",
  filter2ndFloorPlus: "2階以上",
  filter3rdFloorPlus: "3階以上",
  filterTopFloor: "最上階",
  filterElevator: "エレベーター",
  filterAutoLock: "オートロック",
  filterDeliveryBox: "宅配ボックス",
  filterParking: "駐車場あり",
  filterBicycleParking: "駐輪場",

  // Access
  filterWalkToStation: "駅徒歩",
  filterAnyWalkTime: "指定なし",
  filterWithin5Min: "5分以内",
  filterWithin10Min: "10分以内",
  filterWithin15Min: "15分以内",
  filterWithin20Min: "20分以内",

  // New categories
  filterCategoryBathroom: "バス・洗濯",
  filterCategoryKitchen: "キッチン",
  filterCategorySecurity: "セキュリティ",
  filterCategoryListing: "掲載",

  // Bathroom & Laundry
  filterIndoorWasherSpace: "室内洗濯機置場",
  filterReheatingBath: "追い焚き",
  filterBathroomDryer: "浴室乾燥機",
  filterWashletSeat: "温水洗浄便座",
  filterIndependentVanity: "独立洗面台",

  // Kitchen
  filterSystemKitchen: "システムキッチン",
  filterCounterKitchen: "カウンターキッチン",
  filterDishwasher: "食器洗い機",

  // Building extras
  filterSouthFacing: "南向き",
  filterCornerUnit: "角部屋",
  filterBuildingStructure: "構造",
  filterStructureRC: "鉄筋コンクリート",
  filterStructureSteel: "鉄骨造",
  filterStructureWood: "木造",
  filterStructureSRC: "鉄骨鉄筋コンクリート",

  // Security
  filterSecurityCamera: "防犯カメラ",
  filterVideoIntercom: "TVモニタ付インターホン",

  // Parking extras
  filterMotorcycleParking: "バイク置場",

  // Contract
  filterForeignerFriendly: "外国籍OK",
  filterPetsAllowed: "ペット可",
  filterInstrumentsOK: "楽器相談可",
  filterSohoOK: "事務所利用可",
  filterNoGuarantorNeeded: "保証人不要",
  filterMoveInWithin30Days: "即入居可",

  // Listing freshness
  filterListingFreshness: "掲載期間",
  filterFreshnessAny: "指定なし",
  filterFreshness24h: "24時間以内",
  filterFreshness3d: "3日以内",
  filterFreshness7d: "7日以内",
  filterFreshness14d: "14日以内",

  // Theme switcher
  themeSwitchToLight: "ライトモードに切り替え",
  themeSwitchToDark: "ダークモードに切り替え",
};

export const t = (key: keyof Locale, ...args: string[]) =>
  translate(ja, key, ...args);
